module.exports = __webpack_public_path__ + "img/gofiqr-del-din-viden.3d2a16df.png";